import { useContext } from "react"
import { GetApp } from "../../App"
import { PrintShipViewContext, ShipDataType } from "../../App/Context"
import { BlockField, BlockRow } from "../../Components/Block"
import { PrintListBlock } from "../../Components/PrintListBlock"
import { IUnitDefault } from "../../Types"
import { predefined, PrintShipViewData } from "./Context"
import { PrintShipSteeringViewProps } from "./Params"

// Steering systems. Detail-level section, only rendered when at least one is present.
export function PrintShipSteeringView({ data }: PrintShipSteeringViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { shipData } = PrintShipViewData.resolveShipData(data);

  const context = useContext(PrintShipViewContext);
  const includeShipDataType = context?.includeShipDataType || ShipDataType.short;
  const visible = !!(includeShipDataType === ShipDataType.details && shipData?.steeringSystems && shipData.steeringSystems.length > 0);

  return (
    <PrintListBlock title={t("steering_systems")} visible={visible}>
      <BlockRow className="block-row-separated">
        <BlockField label={t("steering_system_main")} className="block-field-210">{shipData?.steeringSystem}</BlockField>
        <BlockField label={t("rudder_no")} className="block-field-120">{shipData?.rudderNumber}</BlockField>
        <BlockField label={t("rudder_shape")} className="block-field-150">{shipData?.rudderShape}</BlockField>
        <BlockField label={t("rudder_drive")}>{shipData?.rudderDrive}</BlockField>
      </BlockRow>

      {/* More SteeringSystems – ShipDataSteeringSystemView */}
      {shipData?.steeringSystems && shipData.steeringSystems.length > 0 && shipData.steeringSystems.map((steeringSystem, index) => (
        <BlockRow key={steeringSystem.id || index} className="block-row-one-row-list">
          <BlockField label={t("steering_type")} className="block-field-150">{steeringSystem.steeringType ? (predefined.steeringType.includes(steeringSystem.steeringType) ? t(`steering_${steeringSystem.steeringType}`) : steeringSystem.steeringType) : steeringSystem.steeringType}</BlockField>
          <BlockField label={t("manufacturer")} className="block-field-210">{steeringSystem.manufacturer}</BlockField>
          <BlockField label={t("model")} className="block-field-150">{steeringSystem.model}</BlockField>
          <BlockField label={t("power")} className="block-field-75">{steeringSystem.power} {steeringSystem.powerUnit || (steeringSystem.power ? IUnitDefault.power : "")}</BlockField>
          <BlockField label={t("comment")}>{steeringSystem.comment}</BlockField>
        </BlockRow>
      ))}
    </PrintListBlock>
  );
}
